enum PageDisplayTypeEnum {
    Desktop = "Desktop",
    Mobile = "Mobile",
    None = "None"
}
export default PageDisplayTypeEnum;